import React from "react";
import { Event } from "../../../../cp/components/Comet";
import { removeDuplicates } from "../../helpers/remove-duplicates";
import { useEventContext } from "../EventContext";

export default () => {
    const { eventDispatch } = useEventContext();

    function onCreateMember(data) {
        eventDispatch((event) => {
            return {
            ...event,
            members: removeDuplicates([...event.members, data], 'id'),
        }});
    }
    
    function onUpdateMember(data) {
        eventDispatch((event) => {
            return ({
                ...event,
                members: removeDuplicates(event.members.map((member) => (member.id === data.id ? data : member)), 'id'),
                stream: event.stream.map((stream) => ({
                    ...stream,
                    episode: stream.episode.map((episode) => ({
                        ...episode,
                        groups: episode.groups.map((group) => ({
                            ...group,
                            members: group.members.map((member) => 
                                member.member.id === data.id && member.member.hide === !data.hide ?
                                {...member, member: {...data}} :
                                {...member}
                            )
                        }))
                    }))
                }))
            })
        });
    }

    function onDeleteMember(data) {
        eventDispatch((event) => ({
            ...event,
            members: event.members.filter(({ id }) => id !== data.id),
        }));
    }

    return (
        <>
            <Event event="create:member" handler={(data) => onCreateMember(data)} />
            <Event event="update:member" handler={(data) => onUpdateMember(data)} />
            <Event event="delete:member" handler={(data) => onDeleteMember(data)} />
        </>
    );
}
